// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"cfbb5036","293":"6ed4770c","296":"6ed4770c","339":"6ed4770c","720":"6ed4770c","915":"39363cb4","983":"6ed4770c"}[chunkId] + ".chunk.css";
};